

export const GET_SINGLE_PRODUCT_REQUEST= "GET_SINGLE_PRODUCT_REQUEST"
export const GET_SINGLE_PRODUCT_SUCCESS= "GET_SINGLE_PRODUCT_SUCCESS"
export const GET_SINGLE_PRODUCT_FAILURE= "GET_SINGLE_PRODUCT_FAILURE"

